import '../../../../assets/css/setContract_forSubmission.css';
// //import '../../../../../assets/css/setContract_forSubmission.css';src\assets\css\setContract_forSubmission.css
import React, { useState, useEffect } from 'react';
import Dialog from '@mui/material/Dialog';
import Fab from '@mui/material/Fab';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DialogContent from '@mui/material/DialogContent';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import DialogTitle from '@mui/material/DialogTitle';
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import Contract_content_view from './contract_content_view';
import { contract_check } from '../../../../services/purchase_service';
import { get_contracts_types } from '../../../../services/for_allServices';
import { Button } from 'react-bootstrap';
import Upload_contract from '../upload_contract/upload_contract';
function Set_simple_contract({ setContract, handleCloseSetContrat, chosenSubmission, purchase_service, id_supplier, contract_details, setContract_details }) {
  const [contracts_types, setContracts_types] = useState(null);
  const [contract_type, setContract_type] = useState(null);
  const [contract_subtypes, setContract_subtypes] = useState(null);
  const [waiting, setWaiting] = useState(true);
  const [upload_contract, setUpload_contract] = useState(false);
 //  console.log("Set_simple_contract");
  function ChooseTypeContrat(index, type) {
    setContract_type(type);
    setContract_subtypes(contracts_types[type]);
  }
  useEffect(() => {
    contract_check(chosenSubmission, "all").then((response) => {
     //  console.log("response==", response.data);

      if (response.data !== "") {
        let rep = response.data;
        setContract_type(Object.keys(rep)[0]);
        setContract_subtypes(rep[Object.keys(rep)[0]]);
        setWaiting(false);
       //  console.log("rep===", rep);

      }
      else {
        get_contracts_types().then((response) => {
         //  console.log(response.data);
          setContracts_types(response.data);
          setWaiting(false);
        }).catch((error) => {
          //console.log(error.response);
        })
      }
    }).catch((error) => {
      //console.log(error.response);
    })

  }, [])

  const import_contract = () => {
    setUpload_contract(true);
  }
  const close_contract_import = () => {
    setUpload_contract(false);
  }
  return (
    <>{
      waiting === true
        ? <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 3 }}
          open={waiting}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        : <Dialog disableEnforceFocus fullWidth={true} maxWidth={'md'} open={setContract} onClose={handleCloseSetContrat} aria-labelledby="form-dialog-title" >
          <DialogTitle id="form-dialog-title">Choisissez le type de contrat </DialogTitle>
          {
            contract_type == null && contract_subtypes == null
              ? <DialogContent className="rateEdit" >
                <div className='contract_type_Container'>
                  {
                    Object.keys(contracts_types).map((key, id) => {
                      return (
                        <div className='contract_type'>
                          <Fab onClick={() => ChooseTypeContrat(chosenSubmission, key)} key={id} size="small" color="secondary" style={{ backgroundColor: '#ef233c' }}> <VisibilityIcon className="my_icon" /> </Fab>
                          <span className='documentsTitle'> {key} </span>
                        </div>
                      )
                    })
                  }
                </div>
                {/* <h4>Ou</h4>
                <div className='contract_type_Container'>
                  <Button
                    className='submit_but'
                    onClick={(e) => {
                      e.stopPropagation();
                      import_contract();
                    }}
                  >
                    Importer un contrat
                  </Button>                  </div> */}
              </DialogContent>
              : <></>
          }
          {
            contract_type != null && contract_subtypes != null
              ? <Contract_content_view contract_type={contract_type} contract_subtypes={contract_subtypes}
                close_contact_type={() => { setContract_type(null); handleCloseSetContrat() }}
                chosenSubmission={chosenSubmission} purchase_service={purchase_service}
                id_supplier={id_supplier} contract_details={contract_details} />
              : <></>
          }
          {upload_contract && contract_details && (
            <Upload_contract
              contract_details={contract_details}
              close_contract_import={close_contract_import}
              open={upload_contract}
            />
          )}

        </Dialog>
    }
    </>
  );
}
export default Set_simple_contract;